import styles from "./DeviceCard.module.css";

export interface DeviceCardProps {
  id: number;
  name: string;
  os: string;
  platform: string;
  isActive: boolean;
  createdAt: string;
  onClick?: () => void;
}

const formatDate = (dateStr: string): string => {
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return dateStr;
  }
};

export const DeviceCard = ({
  id,
  name,
  os,
  platform,
  isActive,
  createdAt,
  onClick,
}: DeviceCardProps) => {
  return (
    <div className={styles.card} onClick={onClick}>
      {/* Status indicator */}
      <div
        className={`${styles.statusDot} ${isActive ? styles.online : styles.offline}`}
      />

      {/* Device info */}
      <div className={styles.info}>
        <strong className={styles.name}>{name || `Device #${id}`}</strong>
        <span className={styles.meta}>
          {os || "Unknown OS"} · {platform || "Unknown platform"}
        </span>
        <span className={styles.date}>Created: {formatDate(createdAt)}</span>
      </div>

      {/* Status label */}
      <span
        className={`${styles.statusLabel} ${isActive ? styles.statusOnline : styles.statusOffline}`}
      >
        {isActive ? "🟢 Online" : "⚪ Offline"}
      </span>
    </div>
  );
};
